import dayjs, { Dayjs } from 'dayjs'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { EmploymentFormValues } from '../../../../store/types/form/EmploymentFormValues'
import {
  isDateWithinContract,
  isValidDateRange,
  periodOverlapsWithOthers,
} from '../../../../store/utils/employmentUtils'
import DateInput from '../../Inputs/DateInput'

type Props = {
  index: number
  contractStart: Dayjs | null
  contractEnd: Dayjs | null
}

const VacationPeriodStartDateInput = ({ index, contractStart, contractEnd }: Props) => {
  const { t } = useTranslation()
  const { control, getValues, trigger } = useFormContext<EmploymentFormValues>()

  return (
    <DateInput
      control={control}
      name={`vacationPeriods.${index}.startDate`}
      label={t('page.employments.table.from')}
      hideHelperText
      rules={{
        required: true,
        validate: {
          periodRange: v => {
            if (!dayjs.isDayjs(v)) return false
            const end = getValues(`vacationPeriods.${index}.endDate`)
            return isValidDateRange(v, end) ? true : t('page.employments.notifications.periodRangeError')
          },
          periodRangeWithinContract: v => {
            if (!dayjs.isDayjs(v)) return false
            return isDateWithinContract(v, contractStart, contractEnd)
              ? true
              : t('page.employments.notifications.periodOutsideContract')
          },
          periodOverlap: v => {
            if (!dayjs.isDayjs(v)) return false
            const end = getValues(`vacationPeriods.${index}.endDate`)
            const allPeriods = getValues('vacationPeriods')
            if (!v || !end) return true
            return !periodOverlapsWithOthers({ startDate: v, endDate: end }, allPeriods, index)
              ? true
              : t('page.employments.notifications.overlappingPeriods')
          },
        },
      }}
      onValueChange={() => {
        trigger(`vacationPeriods.${index}.endDate`)
        trigger(`vacationPeriods.${index}.numberOfDays`)
      }}
    />
  )
}

export default VacationPeriodStartDateInput
